import React, { useState } from "react"
import {
  Form,
  Field,
  reduxForm,
  propTypes,
  fieldPropTypes,
  submit
} from "redux-form"
import { defineMessages, injectIntl } from "react-intl"
import PropTypes from "prop-types"
import _ from "lodash"
// Material Ui
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Dialog from "@material-ui/core/Dialog"
import FormGroup from "@material-ui/core/FormGroup"
import CardHeader from "@material-ui/core/CardHeader"
// ## //
import MenuItem from "@material-ui/core/MenuItem"
import { DialogActions, DialogTitle } from "@material-ui/core"
import { useDispatch } from "react-redux"
import authSlice from "../../api/authSlice"
import FieldTextarea from "../../component/forms/FieldTextarea"
import {
  ButtonCancel,
  ButtonClear,
  ButtonSubmit
} from "../../component/buttons"
import CheckBoxInput from "../../component/forms/CheckBoxInput"
import { words } from "../../i18n/lstrings"
import SelectInput from "../../component/forms/SelectInput"
import withUserProfileDialogForm from "../admin/users/withUserProfileDialogForm"
import UserProfileSelector from "../admin/users/UserProfileSelector"
import { actions as notifier } from "../../component/notifier"
import FieldPassword from "../../component/forms/FieldPassword"

const labels = defineMessages({
  isadmin: {
    id: "user.form.isadmin",
    description: "user Is Admin ??",
    defaultMessage: "Administrator"
  },
  changePwdButton: {
    id: "button.changePassword",
    defaultMessage: "Change password",
    description: "Change password"
  },
  resetPwdButton: {
    id: "button.resetPassword",
    defaultMessage: "Reset password",
    description: "Reset password"
  },
  confirmPassword: {
    id: "title.confirmpassword",
    defaultMessage: "Confirm password",
    description: "Confirm password"
  }
})

const { actions } = authSlice

function ActiveSelector(props) {
  const { input } = props
  const model = [
    { value: "active", text: "ACTIVE" },
    { value: "inactive", text: "INACTIVE" }
  ]

  return (
    <SelectInput
      label="Status"
      input={{
        name: "user-status-selector",
        value: input.value || "active", // default value to active when creating a new user
        onChange: input.onChange
      }}
    >
      {_.map(model, (it, idx) => (
        <MenuItem key={idx} value={it.value}>
          {it.text}
        </MenuItem>
      ))}
    </SelectInput>
  )
}

ActiveSelector.propTypes = {
  ...fieldPropTypes
}

export const UserForm = (props) => {
  // handlers
  const {
    handleSubmit,
    handleSave,
    handleCancel,
    handlePassword,
    handleResetPassword
  } = props
  // real props
  const {
    pristine,
    reset,
    submitting,
    heading,
    permissions,
    initialValues,
    editProfile // from HoC withUserProfileDialogForm
  } = props

  const { intl } = props
  const { formatMessage: format } = intl
  const [changedEmail, setChangedEmail] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState(false)
  const [inputPassword, setInputPassword] = useState("")
  const dispatch = useDispatch()

  const isEditForm = () => initialValues && initialValues._id
  const isAddForm = () => !isEditForm()

  const handleSubmitClick = () => {
    if (isAddForm() || !changedEmail) {
      dispatch(submit("UserForm"))
    } else {
      setConfirmPassword(true)
    }
  }

  const checkMailAndSubmit = async () => {
    try {
      const result = await dispatch(actions.checkPassword(inputPassword))
      if (result && result.data && result.data.status === "match") {
        dispatch(submit("UserForm"))
      }
    } catch (error) {
      dispatch(notifier.enqueueError(error.message))
    }
  }

  const onEmailChange = (event) => {
    setChangedEmail(event.target.value !== initialValues.primaryEmail)
  }

  const doInputPassword = (event) => {
    setInputPassword(event.target.value)
  }

  const handleCancelCheck = () => {
    setConfirmPassword(false)
  }

  const handleEnterKeypress = async (e) => {
    if (e.key === "Enter") {
      await checkMailAndSubmit()
    }
  }

  const isCustomerPage = permissions !== "admin"

  return (
    <div>
      <Form onSubmit={handleSubmit(handleSave)}>
        <Card>
          <CardHeader className="clearfix" title={heading} />
          <CardContent>
            <FormGroup>
              <Field
                component={FieldTextarea}
                id="primaryEmail"
                label={format(words.email)}
                name="primaryEmail"
                placeholder="email@xxxx.xxx"
                readonly={!permissions}
                type="email"
                onChange={onEmailChange}
              />
              <Field
                component={FieldTextarea}
                id="firstName"
                label={format(words.firstName)}
                name="firstName"
                placeholder={format(words.firstName)}
                type="text"
                disabled={permissions !== "admin"}
              />
              <Field
                component={FieldTextarea}
                label={format(words.lastName)}
                id="lastName"
                name="lastName"
                placeholder={format(words.lastName)}
                type="text"
                disabled={permissions !== "admin"}
              />
              <Field
                component={FieldTextarea}
                label={format(words.webportalId)}
                id="webportalIdentifier"
                name="webportalIdentifier"
                type="text"
                disabled
              />
              {permissions === "admin" && (
                <>
                  <Field
                    component={CheckBoxInput}
                    label={format(labels.isadmin)}
                    id="staff"
                    name="staff"
                    type="checkbox"
                  />
                  <Field
                    component={ActiveSelector}
                    label={format(words.status)}
                    value="active"
                    id="status"
                    name="status"
                  />
                  <Field
                    component={UserProfileSelector}
                    label={format(words.userProfile)}
                    id="profile"
                    name="profile"
                    editProfile={editProfile}
                  />
                  <Field
                    component={FieldTextarea}
                    label={format(words.jumpId)}
                    id="jumpIdentifier"
                    name="jumpIdentifier"
                    type="text"
                    disabled
                  />
                </>
              )}
            </FormGroup>
          </CardContent>
          <CardActions>
            {isEditForm() && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={handlePassword}
              >
                {format(labels.changePwdButton)}
              </Button>
            )}
            {isEditForm() && !isCustomerPage && (
              <Button
                variant="outlined"
                color="primary"
                onClick={handleResetPassword}
              >
                {format(labels.resetPwdButton)}
              </Button>
            )}
            {isAddForm() && !isCustomerPage && (
              <ButtonClear disabled={pristine || submitting} onClick={reset} />
            )}
            {!isCustomerPage && <ButtonCancel onClick={handleCancel} />}
            <ButtonSubmit
              type="button"
              disabled={submitting}
              onClick={handleSubmitClick}
            />
          </CardActions>
        </Card>
      </Form>
      <Dialog open={confirmPassword}>
        <DialogTitle>{format(labels.confirmPassword)}</DialogTitle>
        <Field
          autoFocus
          component={FieldPassword}
          label={format(words.password)}
          name="password"
          onChange={doInputPassword}
          onKeyPress={handleEnterKeypress}
        />
        <DialogActions>
          <ButtonCancel onClick={handleCancelCheck} />
          <ButtonSubmit disabled={submitting} onClick={checkMailAndSubmit} />
        </DialogActions>
      </Dialog>
    </div>
  )
}

const validate = (values, props) => {
  const { formatMessage: format } = props.intl
  const errors = {}

  if (!values.username) {
    errors.username = format(words.required)
  }

  if (!values.primaryEmail) {
    errors.primaryEmail = format(words.required)
  }

  if (!values.firstName) {
    errors.firstName = format(words.required)
  }

  if (!values.lastName) {
    errors.lastName = format(words.required)
  }
  return errors
}

UserForm.propTypes = {
  ...propTypes,
  heading: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
  permissions: PropTypes.string.isRequired,
  intl: PropTypes.any.isRequired
}

export default withUserProfileDialogForm(
  injectIntl(
    reduxForm({
      form: "UserForm",
      validate,
      enableReinitialize: true
    })(UserForm)
  )
)
